import { render, staticRenderFns } from "./RoleDropdown.vue?vue&type=template&id=004c7e37&"
import script from "./RoleDropdown.vue?vue&type=script&lang=js&"
export * from "./RoleDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports